import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";


/* Pages */
import Home from "./pages/Home/Home";
import Premium from "./pages/Premium/Premium";
import Redes from "./pages/Redes/Redes";
import Standard from "./pages/Standard/Standard";
import Termos from "./pages/Termos/Termos";
import Valores from "./pages/Valores/Valores";
import ComoFunciona from "./pages/ComoFunciona/ComoFunciona";

function App() {
  const [data, setData] = useState([]);

  const loadPages = async () => {
    const response = await fetch("/static/templates.json");
    const pages = await response.json();
    setData(pages);
  };

  useEffect(() => {
    loadPages();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={data && <Home data={data} />} />
          <Route path="/premium" element={<Premium data={data} />} />
          <Route path="/standard" element={<Standard data={data} />} />
          <Route path="/redes" element={<Redes />} />
          <Route path="/values" element={<Valores />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/como_funciona" element={<ComoFunciona />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
